/** Jobs sahifalari lug'ati (en: manba). */
export default {
  title: "Jobs",
  subtitle: "{{open}} open · {{filled}} filled · {{closed}} closed",
  newJob: "+ New job",
  filters: {
    carrier: "Carrier",
    carrierAll: "Carrier: all",
    state: "State",
    stateAny: "State: any",
    equipment: "Equipment",
    equipmentAny: "Equipment: any",
    status: "Status",
    statusAll: "Status: all",
    searchPlaceholder: "Search job or carrier",
    searchAria: "Search jobs",
  },
  empty: {
    filtered: "No jobs match these filters",
    none: "No open jobs",
    manager: "Create a job for a carrier that is hiring.",
    viewer: "Your manager adds carrier jobs.",
  },
  columns: {
    job: "Job",
    carrier: "Carrier",
    states: "States",
    experience: "Experience",
    pay: "Pay",
    homeTime: "Home time",
    equipment: "Equipment",
    status: "Status",
    candidates: "Candidates",
  },
  candidates_one: "{{count}} candidate",
  candidates_other: "{{count}} candidates",
  hiredOf: "{{hired}} of {{openings}} hired",
  pagination: "jobs",
  detail: {
    notFound: "Job not found.",
    posted: "posted {{date}}",
    carrierStatus: "carrier {{status}}",
    openings: "Openings:",
    openingsTail_one: "{{count}} candidate · closes when all openings are filled",
    openingsTail_other: "{{count}} candidates · closes when all openings are filled",
    notOpen: "This job is not open",
    submitDriver: "Submit driver",
    requirements: "Requirements",
    cdl: "CDL",
    cdlClass: "Class {{cls}}",
    experience: "Experience",
    hiringStates: "Hiring states",
    mvr: "MVR",
    dui: "DUI / DWI",
    drugTest: "Drug test",
    endorsements: "Endorsements",
    notSpecified: "not specified",
    notRequired: "not required",
    paySchedule: "Pay & schedule",
    pay: "Pay",
    homeTime: "Home time",
    equipment: "Equipment",
    signOnBonus: "Sign-on bonus",
    notes: "Notes",
    matchingTitle: "Matching drivers · coming later",
    matchingText: "Auto-matching by state, equipment and experience (stage 3). Until then use \"Submit driver\": it warns when a driver does not meet the requirements.",
    contactTitle: "Carrier contact & submission",
    contactUnavailable: "Carrier details unavailable.",
    recruiter: "Recruiter",
    phone: "Phone",
    email: "Email",
    method: "Method",
    replyTime: "Reply time",
    candidatesTitle: "Candidates ({{count}})",
    noSubmissions: "No submissions yet",
    myCandidates: "My candidates",
    candidates: "Candidates",
    status: "Status",
    submitted: "Submitted",
    carrierReply: "Carrier reply",
    hiddenOthers_one: "{{count}} candidate from other recruiters (name hidden)",
    hiddenOthers_other: "{{count}} candidates from other recruiters (names hidden)",
    noCandidates: "No candidates yet. Submit a Qualified or Docs driver.",
    shortBackground: "Background",
  },
  submit: {
    title: "Submit driver to job",
    searchPlaceholder: "Search my drivers...",
    searchAria: "Search drivers",
    eligibleHint: "Eligible: Qualified or Docs. Drivers already submitted to this job are not listed.",
    noMatch: "No eligible drivers match.",
    moreHint: "Showing {{shown}} of {{total}} — type a name to find the rest.",
    noEligible: "No eligible drivers. Move a driver to Qualified or Docs first.",
    matches: "matches requirements",
    notePlaceholder: "Note to carrier (optional)",
    withWarnings: "{{name}} submitted with warnings",
    submitted: "{{name}} submitted to {{carrier}}",
    failed: "Could not submit the driver.",
  },
  form: {
    chooseCarrier: "Choose a carrier.",
    titleRequired: "Job title is required.",
    saved: "Job saved",
    created: "Job created",
    saveFailed: "Could not save the job.",
    editTitle: "Edit job",
    newTitle: "New job",
    carrier: "Carrier",
    choose: "Choose…",
    jobTitle: "Job title",
    titlePlaceholder: "Dry van OTR, TX",
    status: "Status",
    openings: "Openings",
    minExperience: "Min experience (months)",
    cdlClass: "CDL class",
    hiringStates: "Hiring states",
    all48: "All 48 states",
    pickStates: "Pick the states, or all 48",
    pay: "Pay",
    payPlaceholder: "$1,400-1,700 / week",
    homeTime: "Home time",
    driverTypes: "Which drivers they hire",
    freight: "Freight",
    drivingType: "Driving type",
    equipment: "Equipment",
    equipmentPlaceholder: "2024 dry van, automatic",
    signOnBonus: "Sign-on bonus",
    bonusPlaceholder: "$2,000 after 90 days",
    posted: "Posted",
    endorsements: "Endorsements required",
    mvr: "MVR",
    mvrPlaceholder: "≤ 2 moving violations in 3 years",
    dui: "DUI / DWI",
    duiPlaceholder: "none in the last 10 years",
    drugTest: "Drug test",
    drugPlaceholder: "pre-employment, hair + urine",
    notes: "Notes",
  },
};
